import { ErrorBoundary } from '@sentry/nextjs'
import dynamic from 'next/dynamic'
import type { ReactNode } from 'react'
import React, { Component } from 'react'

import HNTranslationContext from '@/context/HNTranslationContext'
import { setHeaders } from '@/lib/helpers/authHelpers'
import type { IKeyValueMap } from '@/types/common'

const HNSegment = dynamic(
  () => import('@/components/users/shared/integration_snippets/HNSegment')
)

const HNPaddleAnalytics = dynamic(
  () => import('@/components/users/shared/HNPaddleAnalytics')
)

interface IPropTypes {
  children: ReactNode
  session?: string | null
  translations: any
  widgetKey?: string
  subdomain?: string
}
interface IStateTypes {
  translations: IKeyValueMap
}

export default class PreProcessWrapper extends Component<
  IPropTypes,
  IStateTypes
> {
  constructor(props: IPropTypes) {
    super(props)
    setHeaders(props.session, props.widgetKey, props.subdomain)
    this.state = { translations: this.props.translations }
  }

  updateContext = (newTranslation: IKeyValueMap) => {
    this.setState({
      translations: { ...this.state.translations, ...newTranslation },
    })
  }

  render() {
    return (
      <HNTranslationContext.Provider
        value={{
          ...this.state.translations,
          updateTranslationContext: this.updateContext,
        }}
      >
        <>
          {this.props.children}
          <ErrorBoundary>
            <HNSegment />
            <HNPaddleAnalytics />
          </ErrorBoundary>
        </>
      </HNTranslationContext.Provider>
    )
  }
}
